import { useState } from 'react';
import { FormControl, FormLabel, Input, VStack } from '@chakra-ui/react';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import Modal from '@/trio-ui/Modal';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { url: string; targetKeyword: string }) => Promise<void>;
};

const NewContentAnalysisFormComponent = function ({ open, onClose, onSubmit }: Props): JSX.Element {
  const [url, setUrl] = useState('');
  const [targetKeyword, setTargetKeyword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!url.trim() || !targetKeyword.trim()) return;
    setSubmitting(true);
    try {
      await onSubmit({ url: url.trim(), targetKeyword: targetKeyword.trim() });
      setUrl('');
      setTargetKeyword('');
    } finally {
      setSubmitting(false);
    }
  };

  const body = (
    <VStack spacing={4} align="stretch">
      <FormControl>
        <FormLabel fontSize="sm">Page URL</FormLabel>
        <Input
          placeholder="https://example.com/blog/my-post"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          autoFocus
        />
      </FormControl>
      <FormControl>
        <FormLabel fontSize="sm">Target Keyword</FormLabel>
        <Input
          placeholder="e.g. best crm software"
          value={targetKeyword}
          onChange={(e) => setTargetKeyword(e.target.value)}
        />
      </FormControl>
    </VStack>
  );

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      modalTitle="New Content Analysis"
      headerIcon={ArticleOutlinedIcon}
      bodyRender={body}
      onConfirmClick={handleSubmit}
      onConfirmLabel={submitting ? 'Analyzing...' : 'Analyze'}
      isButtonDisabled={!url.trim() || !targetKeyword.trim() || submitting}
      isLoading={submitting}
      isCentered
      size="md"
    />
  );
};

export default NewContentAnalysisFormComponent;
